import { useEffect, useState } from "react";
import { initializeI18n } from "../i18n/i18n";
import {
  TenantConfig,
  loadTheme,
  setFavicon,
  setSeoTags,
  isTenantNotAvailable,
  getTenantNotAvailableReason,
  getTenantNotAvailableInfo,
  TenantNotAvailableReason,
  TenantNotAvailableInfo,
} from "./tenantConfig";

const useTenantInitialization = () => {
  const [theme, setTheme] = useState<any>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [showSplash, setShowSplash] = useState(true);
  const [notAvailable, setNotAvailable] = useState(false);
  const [notAvailableReason, setNotAvailableReason] =
    useState<TenantNotAvailableReason>("not_found");
  const [notAvailableInfo, setNotAvailableInfo] =
    useState<TenantNotAvailableInfo | null>(null);

  useEffect(() => {
    const initializeTenant = async () => {
      try {
        const tenantConfig = await TenantConfig();
        // Shared deployment: an unknown / not-yet-activated slug 404s. Stop here
        // and let the caller render the not-available page (step 13).
        if (isTenantNotAvailable()) {
          setNotAvailableReason(getTenantNotAvailableReason());
          setNotAvailableInfo(getTenantNotAvailableInfo());
          setNotAvailable(true);
          setIsLoading(false);
          return;
        }
        await setFavicon();
        await setSeoTags();
        const theme = await loadTheme();
        setTheme(theme);
        await initializeI18n(tenantConfig);
        setIsLoading(false);
      } catch (error) {
        console.error("Error initializing tenant:", error);
        setIsLoading(false);
      }
    };
    initializeTenant();
  }, []);

  useEffect(() => {
    const splashTimeout = setTimeout(() => {
      setShowSplash(false);
    }, 2000);

    return () => clearTimeout(splashTimeout);
  }, []);

  return {
    theme,
    isLoading,
    showSplash,
    notAvailable,
    notAvailableReason,
    notAvailableInfo,
  };
};

export default useTenantInitialization;
